export default __webpack_public_path__ + "static/media/logo.8d1d7c39.svg";